import React from "react";
import { AppProvider } from "context/app-context";
import { ErrorBoundary, PageLayout } from "components/templates";
import { BrowserRouter } from "react-router";
import { AppRouter } from "routes";
import { CartProvider } from "context/cart-context";
import { SnackbarNotificationProvider } from "providers/SnackbarNotificationProvider";
import { AppContainer } from "components/UI/atoms";
import { SardineProvider } from "providers/SardineProvider";
import { CheckoutProvider } from "context/checkout-context";
import { GoogleReCaptchaProvider } from "providers/GoogleReCaptchaProvider";

const App = () => (
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true
    }}
  >
    <GoogleReCaptchaProvider>
      <AppContainer>
        <SardineProvider>
          <SnackbarNotificationProvider>
            <AppProvider>
              <CartProvider>
                <CheckoutProvider>
                  <ErrorBoundary>
                    <PageLayout>
                      <AppRouter />
                    </PageLayout>
                  </ErrorBoundary>
                </CheckoutProvider>
              </CartProvider>
            </AppProvider>
          </SnackbarNotificationProvider>
        </SardineProvider>
      </AppContainer>
    </GoogleReCaptchaProvider>
  </BrowserRouter>
);

export default App;
